import React, { Fragment, useReducer } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";



// images
import { IMAGES } from "../../../../constant/theme";

const productListBlog = [
  {image: IMAGES.Product2, title:"Solid Women's V-neck Dark T-Shirt", price:'320'},
  {image: IMAGES.Product3, title:"Women White Plain Cotton Kurta", price:'430'},
  {image: IMAGES.Product4, title:"Women Cotton Printed Kurta Set", price:'140'},
  {image: IMAGES.Product5, title:"Solid Women's V-neck Dark T-Shirt", price:'220'},
  {image: IMAGES.Product6, title:"Women White Plain Cotton Kurta", price:'450'},
  {image: IMAGES.Product7, title:"Women Cotton Printed Kurta Set", price:'160'},
];

const init = false;
const reducer = (state, action) =>{
	if(action.type==='reviewModal'){
		return { ...state, reviewModal: !state.reviewModal}
	}
	return state;
}

const ProductList = () => {
  const [state, dispatch] = useReducer(reducer ,init);	  
  return (
    <Fragment>      
      <div className="container-fluid mh-auto">
          <div className="row">
             {productListBlog.map((item, index)=>(            
                <div className="col-lg-12 col-xl-6 col-xxl-4" key={index}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row m-b-30">
                        <div className="col-md-5 col-xxl-12">
                          <div className="new-arrival-product mb-4 mb-xxl-4 mb-md-0">
                            <div className="new-arrivals-img-contnent">
                              <img className="img-fluid" src={item.image} alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7 col-xxl-12">
                          <div className="new-arrival-content position-relative">
                            <h4>
                              <Link to="ecom-product-detail">
                               {item.title}
                              </Link>
                            </h4>
                            <div className="comment-review star-rating">
                              <ul>
                                {" "}
                                <li>
                                  <i className="fa fa-star" />
                                </li>{" "}
                                <li>
                                  <i className="fa fa-star" />
                                </li>{" "}
                                <li>
                                  <i className="fa fa-star" />
                                </li>{" "}
                                <li>
                                  <i className="fa fa-star-half-alt" />
                                </li>{" "}
                                <li>
                                  <i className="fa fa-star-half-alt" />
                                </li>
                              </ul>
                              <span className="review-text">(34 reviews) / </span>
                              <Link
                                className="product-review"
                                to="/ecom-product-list"
                                data-toggle="modal"
                                onClick={() => dispatch({type:'reviewModal'})}
                                data-target="#reviewModal"
                              >
                                Write a review?
                              </Link>
                              <p className="price">${item.price}.00</p>
                            </div>
                            <p>
                              Availability:{" "}
                              <span className="item">
                                {" "}
                                In stock{" "}
                                <i className="fa fa-check-circle text-success" />
                              </span>
                            </p>
                            <p>
                              Product code: <span className="item">0405689</span>{" "}
                            </p>
                            <p>
                              Brand: <span className="item">Lee</span>
                            </p>
                            <p className="text-content">
                              There are many variations of passages of Lorem Ipsum
                              available, but the majority have suffered alteration in
                              some form, by injected humour, or randomised words.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}            
            {/* review */}
            <Modal show={state.reviewModal} onHide={() => dispatch({type:'reviewModal'})} className="modal fade" id="reviewModal">
              <>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Review</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-dismiss="modal"
                      onClick={() => dispatch({type:'reviewModal'})}
                    >
                    </button>
                  </div>
                  <div className="modal-body">
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();                        
                          dispatch({type:'reviewModal'})
                      }}
                    >
                      <div className="text-center mb-4">
                        <img
                          className="img-fluid rounded"
                          width={78}
                          src={IMAGES.Avatar}
                          alt="DexignZone"
                        />
                      </div>
                      <div className="form-group">
                        <div className="rating-widget mb-4 text-center">
                          {/* Rating Stars Box */}
                          <div className="rating-stars">
                            <ul
                              id="stars"
                              className="d-flex justify-content-center align-items-center"
                            >	
                  <li>
                    <i className="fa fa-star me-1" />
                  </li>{" "}
                  <li>
                    <i className="fa fa-star me-1" />
                  </li>{" "}
                  <li>
                    <i className="fa fa-star me-1" />
                  </li>{" "}
                  <li>
                    <i className="fa fa-star me-1" />
                  </li>{" "}
                  <li>
                    <i className="fa fa-star" />
                  </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <textarea
                          className="form-control"
                          placeholder="Comment"
                          rows={5}
                          defaultValue={""}
                        />
                      </div>
                      <button className="btn btn-success btn-block">RATE</button>
                    </form>
                  </div>
                </div>
              </>
            </Modal>
          </div>
      </div>
    </Fragment>
  );
};

export default ProductList;
